import {
  NavigateOptions,
  To,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

const useNavigateWithQuery = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (to: To, options?: NavigateOptions) => {
    const combinedSearchParams = new URLSearchParams(searchParams);

    if (typeof to === "string") {
      navigate(
        {
          pathname: to,
          search: combinedSearchParams.toString(),
        },
        options
      );
      return;
    }

    if (to.search) {
      new URLSearchParams(to.search).forEach((value, name) => {
        if (value !== undefined && value !== null && value.trim() !== "") {
          // if value is in params
          combinedSearchParams.append(name, value);
        } else {
          // if not - delete
          combinedSearchParams.delete(name);
        }
      });
    }

    navigate(
      {
        pathname: to.pathname,
        search: combinedSearchParams.toString(),
      },
      options
    );
  };
};

export default useNavigateWithQuery;
